import { HttpData, HttpNoData } from "../../../Core";

export async function updateCategoryPriority(id, priority, jwt) {
    const response = await HttpData(
        `/api/v1/products/categories/new/${id}/priority`,
        'PUT',
        jwt,
        priority
    );
    return response.statusSuccessful;
}

export async function reorderCategories(requests, jwt) {
    const response = await HttpData(
        `/api/v1/products/categories/new/reorder`,
        'PUT',
        jwt,
        requests
    );
    return response.statusSuccessful;
}

// Продукты
export async function updateProductPriority(id, priority, jwt) {
    const response = await HttpData(
        `/api/v1/newproducts/new/${id}/priority`,
        'PUT',
        jwt,
        priority
    );
    return response.statusSuccessful;
}

export async function reorderProducts(requests, jwt) {
    const response = await HttpData(
        `/api/v1/newproducts/new/reorder`,
        'PUT',
        jwt,
        requests
    );
    return response.statusSuccessful;
}

export async function getNewPlaces(jwt) {

    const response = await HttpNoData(`/api/v1/products/places/new`, 'GET', jwt);

    return response.data;
}

export async function createNewProductCategory(name, priority, jwt, placeIds = []) {
    const response = await HttpData(`/api/v1/products/categories/new`, 'POST', jwt, {
        name: name,
        priority: priority,
        placeIds: placeIds
    });
    return response.data;
}

export async function deleteNewProductCategory(id, statusProducts, newCategory, jwt) {

    const response = await HttpNoData(`/api/v1/products/categories/new/${id}?${statusProducts == 'delete' ? 'products=delete' : `products=move&newCategory=${newCategory}`}`, 'DELETE', jwt);

    return response.statusSuccessful;
}

export async function updateNewProductCategory(id, name, priority, jwt, placeIds = []) {
    const response = await HttpData(`/api/v1/products/categories/new/${id}`, 'PUT', jwt, {
        name: name,
        priority: priority,
        placeIds: placeIds
    });
    return response.statusSuccessful;
}

export async function getNewCategoryPlaces(categoryId, jwt) {
    const response = await HttpNoData(
        `/api/v1/products/categories/new/${categoryId}/places`,
        'GET',
        jwt
    );
    return response.data;
}

export async function createNewPlace(name, isMarketPlace, jwt) {

    const response = await HttpData(`/api/v1/products/places/new`, 'POST', jwt, {
        name: name,
        isMarketPlace: isMarketPlace
    });

    return response.data;
}

export async function deleteNewPlace(id, statusSends, newPlace, jwt) {

    const response = await HttpNoData(`/api/v1/products/places/new/${id}?${statusSends == 'delete' ? 'sends=delete' : `sends=move&newPlace=${newPlace}`}`, 'DELETE', jwt);

    return response.statusSuccessful;
}

export async function updateNewPlace(id, name, isMarketPlace, jwt) {

    const response = await HttpData(`/api/v1/products/places/new/${id}`, 'PUT', jwt, {
        name: name,
        isMarketPlace: isMarketPlace
    });

    return response.statusSuccessful;
}

export async function getNewProductCategories(jwt, includePlaces = false) {
    const url = includePlaces
        ? `/api/v1/products/categories/new?includePlaces=true`
        : `/api/v1/products/categories/new`;

    const response = await HttpNoData(url, 'GET', jwt);
    return response.data;
}

// NOW ORDERS ARE USED Instead of SENDS
// export async function createNewProductSend(productId, value, date, placeId, jwt) {
//     let dateStr = date;
//     if (date instanceof Date) {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         dateStr = `${year}-${month}-${day}`;
//     }
//     const response = await HttpData(`/api/v1/newProductsSends/new/${dateStr}`, 'POST', jwt, {
//         productId,
//         value,
//         placeId
//     });
//     return response.data;
// }

// export async function getNewProductsSends(date, placeId, jwt) {
//     let dateStr = date;
//     if (date instanceof Date) {
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0');
//         const day = String(date.getDate()).padStart(2, '0');
//         dateStr = `${year}-${month}-${day}`;
//     }
//     const response = await HttpNoData(`/api/v1/newProductsSends/new/${dateStr}?placeId=${placeId}`, 'GET', jwt);
//     return response.data;
// }

// // use and create
// export async function updateNewProductSend(id, value, jwt) {

//     const response = await HttpNoData(`/api/v1/newProductsSends/new/${id}/${value}`, 'PUT', jwt);

//     return response.statusSuccessful;
// }

// // use and create
// export async function deleteNewProductSend(id, jwt) {

//     const response = await HttpNoData(`/api/v1/newProductsSends/new/${id}`, 'DELETE', jwt);

//     return response.statusSuccessful;
// }


// Получить значения бюджетов для продукта
export async function getProductBudgetValues(productId, jwt) {
    const response = await HttpNoData(`/api/v1/newproducts/new/${productId}/budget-values`, 'GET', jwt);
    return response.data;
}

// Обновить значения бюджетов для продукта
export async function updateProductBudgetValues(productId, values, jwt) {
    const response = await HttpData(`/api/v1/newproducts/new/${productId}/budget-values`, 'PUT', jwt, values);
    return response.statusSuccessful;
}

export async function createNewProduct(body, jwt) {
    const response = await HttpData(`/api/v1/newproducts/new`, 'POST', jwt, {
        name: body.name,
        coefficient: body.coefficient,
        categoryId: body.categoryId,
        placeIds: body.placeIds || [],
        priority: body.priority || 0,
        productType: body.productType || 0
    });
    return response.data;
}


export async function addNewProductToPlace(productId, placeId, jwt) {
    const response = await HttpNoData(
        `/api/v1/newproducts/new/${productId}/places/${placeId}`,
        'POST',
        jwt
    );
    return response.statusSuccessful;
}


export async function getNewProductPlaces(productId, jwt) {
    const response = await HttpNoData(
        `/api/v1/newproducts/new/${productId}/places`,
        'GET',
        jwt
    );
    return response.data;
}

export async function getNewProducts(jwt) {
    const response = await HttpNoData(`/api/v1/newproducts/new?includePlaces=true`, 'GET', jwt);

    if (!response.statusSuccessful)
        console.log(response.error);

    return response.data;
}

// use and create
export async function updateNewProduct(id, body, jwt) {
    const response = await HttpData(`/api/v1/newproducts/new/${id}`, 'PUT', jwt, {
        name: body.name,
        coefficient: body.coefficient,
        categoryId: body.categoryId,
        placeIds: body.placeIds || [],
        priority: body.priority,
        productType: body.productType
    });
    return response.statusSuccessful;
}

// use and create
export async function deleteNewProduct(id, jwt) {

    const response = await HttpNoData(`/api/v1/newproducts/new/${id}`, 'DELETE', jwt);

    return response.statusSuccessful;
}

// Работы для продуктов
export async function getProductWorks(productId, jwt) {
    const response = await HttpNoData(
        `/api/v1/productworks/by-product/${productId}`,
        'GET',
        jwt
    );
    return response.data;
}

export async function getProductWorksLinks(productId, jwt) {
    const response = await HttpNoData(
        `/api/v1/productworks/product/${productId}`,
        'GET',
        jwt
    );
    return response.data;
}

export async function createOrUpdateProductWork(productId, extraWorkId, value, jwt) {
    const response = await HttpData(
        `/api/v1/productworks`,
        'POST',
        jwt,
        {
            productId: productId,
            extraWorkId: extraWorkId,
            value: value
        }
    );
    return response.statusSuccessful;
}

export async function deleteProductWork(productId, extraWorkId, jwt) {
    const response = await HttpData(
        `/api/v1/productworks`,
        'DELETE',
        jwt,
        {
            productId: productId,
            extraWorkId: extraWorkId
        }
    );
    return response.statusSuccessful;
}

export async function bulkUpdateProductWorks(productId, workIds, customCoefficients, quantityCoefficients, jwt) {
    const response = await HttpData(
        `/api/v1/productworks/product/${productId}/bulk`,
        'PUT',
        jwt,
        {
            extraWorkIds: workIds,
            customCoefficients: customCoefficients || {},
            quantityCoefficients: quantityCoefficients || {}
        }
    );
    return response.data;
}

export async function updateWorkCoefficient(productId, extraWorkId, customCoefficient, jwt) {
    const response = await HttpData(
        `/api/v1/productworks/product/${productId}/work/${extraWorkId}/coefficient`,
        'PATCH',
        jwt,
        customCoefficient
    );
    return response.data;
}

export async function exportProductsToExcel(jwt) {
    const response = await fetch(`/api/v1/productexport/export`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${jwt}`,
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
    });

    if (!response.ok) {
        throw new Error(`Ошибка экспорта: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Продукция_и_работы_${new Date().toISOString().slice(0, 10)}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}



// Заказы
export async function getOrders(date, placeId, jwt) {
    const params = new URLSearchParams();
    if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        params.append('date', `${year}-${month}-${day}`);
    }
    if (placeId) params.append('placeId', placeId);
    const response = await HttpNoData(`/api/v1/products/orders?${params}`, 'GET', jwt);
    return response.data;
}

export async function getOrder(orderId, jwt) {
    const response = await HttpNoData(`/api/v1/products/orders/${orderId}`, 'GET', jwt);
    return response.data;
}

export async function createOrder(name, orderDate, placeId, jwt) {
    const year = orderDate.getFullYear();
    const month = String(orderDate.getMonth() + 1).padStart(2, '0');
    const day = String(orderDate.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;
    const response = await HttpData(`/api/v1/products/orders`, 'POST', jwt, {
        name,
        orderDate: dateStr,
        placeId
    });
    return response.data;
}

export async function updateOrderName(orderId, name, jwt) {
    await HttpData(`/api/v1/products/orders/${orderId}`, 'PUT', jwt, { name });
}

export async function deleteOrder(orderId, jwt) {
    await HttpNoData(`/api/v1/products/orders/${orderId}`, 'DELETE', jwt);
}

export async function updateOrderSends(orderId, sends, jwt) {
    await HttpData(`/api/v1/products/orders/${orderId}/sends`, 'PUT', jwt, sends);
}

export async function getOrdersHistory(jwt, page = 1, pageSize = 20) {
    const params = new URLSearchParams({ page, pageSize });
    const response = await HttpNoData(`/api/v1/products/orders/history?${params}`, 'GET', jwt);
    return response.data;
}

export async function getMissingDays(year, month, jwt) {
    const params = new URLSearchParams();
    if (year) params.append('year', year);
    if (month) params.append('month', month);
    const response = await HttpNoData(`/api/v1/products/orders/missing-days?${params}`, 'GET', jwt);
    return response.data;
}


// Брак
export async function getDefectiveBatches(date, jwt) {
    const params = new URLSearchParams();
    if (date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        params.append('date', `${year}-${month}-${day}`);
    }
    const response = await HttpNoData(`/api/v1/defective/batches?${params}`, 'GET', jwt);
    return response.data;
}

export async function getDefectiveBatch(batchId, jwt) {
    const response = await HttpNoData(`/api/v1/defective/batches/${batchId}`, 'GET', jwt);
    return response.data;
}

export async function createDefectiveBatch(batchDate, comment, jwt) {
    const year = batchDate.getFullYear();
    const month = String(batchDate.getMonth() + 1).padStart(2, '0');
    const day = String(batchDate.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;

    const response = await HttpData(`/api/v1/defective/batches`, 'POST', jwt, {
        batchDate: dateStr,
        comment
    });
    return response.data;
}

export async function updateDefectiveBatchComment(batchId, comment, jwt) {
    await HttpData(`/api/v1/defective/batches/${batchId}`, 'PUT', jwt, { comment });
}

export async function deleteDefectiveBatch(batchId, jwt) {
    await HttpNoData(`/api/v1/defective/batches/${batchId}`, 'DELETE', jwt);
}

export async function updateDefectiveBatchItems(batchId, items, jwt) {
    await HttpData(`/api/v1/defective/batches/${batchId}/items`, 'PUT', jwt, items);
}

export async function getDefectiveBatchesHistory(jwt) {
    const response = await HttpNoData(`/api/v1/defective/batches/history`, 'GET', jwt);
    return response.data;
}
export async function getBulkProductWorks(productIds, jwt) {
    const response = await HttpData(
        `/api/v1/productworks/by-product-ids`,
        'POST',
        jwt,
        productIds
    );
    return response.data;
}
export async function getExtraWorks(jwt) {
    const url = `/api/v0/ExtraWorks`;
    const response = await HttpNoData(url, 'GET', jwt);
    return response.data;
}

export async function getProductMappingBySource(sourceType, sourceProductId, jwt) {
    const response = await HttpNoData(
        `/api/v1/productmapping/by-source?sourceType=${sourceType}&sourceProductId=${sourceProductId}`,
        'GET',
        jwt
    );
    return response.data;
}

export async function getProductMappingsBySourceIds(sourceType, sourceProductIds, jwt) {
    const response = await HttpData(
        `/api/v1/productmapping/by-source-ids`,
        'POST',
        jwt,
        { sourceType, sourceProductIds }
    );
    return response.data;
}

export async function getProductSizeRangeMappingsBySource(sourceType, sourceProductId, jwt) {
    const response = await HttpNoData(
        `/api/v1/productsizerangemapping/by-source?sourceType=${sourceType}&sourceProductId=${sourceProductId}`,
        'GET',
        jwt
    );
    return response.data;
}

export async function getProductSizeRangeMappingsBySourceIds(sourceType, sourceProductIds, jwt) {
    const response = await HttpData(
        `/api/v1/productsizerangemapping/by-source-ids`,
        'POST',
        jwt,
        { sourceType, sourceProductIds }
    );
    return response.data;
}

export async function createProductSizeRangeMapping(data, jwt) {
    const response = await HttpData(
        `/api/v1/productsizerangemapping`,
        'POST',
        jwt,
        data
    );
    return response;
}

export async function deleteProductSizeRangeMapping(id, jwt) {
    const response = await HttpNoData(
        `/api/v1/productsizerangemapping/${id}`,
        'DELETE',
        jwt
    );
    return response;
}

export async function getAdditionMappingsBySourceIds(sourceType, sourceAdditionIds, jwt) {
    const response = await HttpData(
        `/api/v1/additionmapping/by-source-ids`,
        'POST',
        jwt,
        { sourceType, sourceAdditionIds }
    );
    return response.data;
}

export async function getAdditionSizeRangeMappingsBySource(sourceType, sourceAdditionId, jwt) {
    const response = await HttpNoData(
        `/api/v1/additionsizerangemapping/by-source?sourceType=${sourceType}&sourceAdditionId=${sourceAdditionId}`,
        'GET',
        jwt
    );
    return response.data;
}

export async function getAdditionSizeRangeMappingsBySourceIds(sourceType, sourceAdditionIds, jwt) {
    const response = await HttpData(
        `/api/v1/additionsizerangemapping/by-source-ids`,
        'POST',
        jwt,
        { sourceType, sourceAdditionIds }
    );
    return response.data;
}

export async function createAdditionSizeRangeMapping(data, jwt) {
    const response = await HttpData(
        `/api/v1/additionsizerangemapping`,
        'POST',
        jwt,
        data
    );
    return response;
}

export async function deleteAdditionSizeRangeMapping(id, jwt) {
    const response = await HttpNoData(
        `/api/v1/additionsizerangemapping/${id}`,
        'DELETE',
        jwt
    );
    return response;
}